import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { SR_API_ACTION_CODEBOX_REGISTER } from 'api/actionTypes';

import log from 'client/lib/log';
import branch from 'client/core/branch';
import postWithState from 'client/actions/postWithState';
import withApiState from 'client/helpers/withApiState';
import getCodeboxListAction from 'client/actions/Codebox/getCodeboxList';
import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import ButtonDeprecated from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

const codeboxRegisterDeviceFormFields = [
  {
    id: 'serialNumber',
    title: 'Codebox Serial Number',
    type: 'short_text',
    validations: ['required'],
    properties: {
      placeholder: '20119390',
    },
  },
  {
    id: 'adminCode',
    title: 'Codebox Admin Code',
    label: 'This code is used to update other codes. This is NOT the master lock code.',
    type: 'short_text',
    validations: ['required'],
    properties: {
      placeholder: '1234',
    },
  },
  {
    id: 'masterCode',
    title: 'Codebox Vendor Code',
    label: 'Fixed lock vendor/master code. This code can be shared with partners.',
    type: 'short_text',
    validations: ['required'],
    properties: {
      placeholder: '1234',
    },
  },
  {
    id: 'shackleCode',
    title: 'Codebox Shackle Code',
    type: 'short_text',
    validations: ['required'],
    properties: {
      placeholder: '1234',
    },
  },
];

@branch()
@withApiState({
  registerCodeboxDeviceApiState: {
    action: SR_API_ACTION_CODEBOX_REGISTER,
  },
})
class SrCodeboxRegisterDeviceForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    registerCodeboxDeviceApiState: PropTypes.object.isRequired,
  };

  _onSubmit = ({ serialNumber, shackleCode, adminCode, masterCode }, formikBag) => {
    const { dispatch } = this.props;
    dispatch(postWithState, {
      action: SR_API_ACTION_CODEBOX_REGISTER,
      payload: {
        serialNumber,
        masterCode,
        shackleCode,
        adminCode,
      },
    })
      .then(() => {
        formikBag.resetForm();
        return dispatch(getCodeboxListAction);
      })
      .catch((error) => {
        log.error(error);
      });
  };

  render() {
    const { registerCodeboxDeviceApiState } = this.props;

    if (registerCodeboxDeviceApiState.isBusy) {
      return <div className="loading-gif" />;
    }

    return (
      <Formik
        enableReinitialize
        onSubmit={this._onSubmit}
        initialValues={createInitialValues({
          formFields: codeboxRegisterDeviceFormFields,
        })}
        validate={createFormValidationFn(codeboxRegisterDeviceFormFields)}
        render={(formikBag) => (
          <Form className="p-relative">
            {codeboxRegisterDeviceFormFields.map((formField) => (
              <SrFormikField key={formField.id} formField={formField} formikBag={formikBag} />
            ))}
            {registerCodeboxDeviceApiState.error && (
              <div className="formMessage error">
                <span>{registerCodeboxDeviceApiState.error.message}</span>
              </div>
            )}
            <ButtonDeprecated type="submit" disabled={!formikBag.isValid}>
              Register Codebox
            </ButtonDeprecated>
          </Form>
        )}
      />
    );
  }
}

SrCodeboxRegisterDeviceForm.displayName = 'SrCodeboxRegisterDeviceForm';

export default SrCodeboxRegisterDeviceForm;
